import { render, staticRenderFns } from "./Elevator.vue?vue&type=template&id=b27f5022&scoped=true&"
import script from "./Elevator.vue?vue&type=script&lang=js&"
export * from "./Elevator.vue?vue&type=script&lang=js&"
import style0 from "./Elevator.vue?vue&type=style&index=0&id=b27f5022&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27f5022",
  null
  
)

export default component.exports